import { useEffect, useState } from 'react';
import { InputNumber, Typography } from 'antd';
import { SkupremeModal } from '../../components';
import { HoverBorderButton, StyledButton } from '../../elements';
import { ItemService, ToastMessage } from '../../utility';

const { Text } = Typography;

export function EditRestockThreshold({ item, open, onClose, refresh, warehouseId }) {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const itemId = item?.productId ?? item?._id;

  useEffect(() => {
    if (!open || !itemId || !warehouseId) {
      return;
    }

    let active = true;
    const fetchThreshold = async () => {
      try {
        setLoading(true);
        const res = await ItemService.getRestockThreshold(itemId, warehouseId);
        if (active) {
          setValue(
            res?.pickingRestockThreshold === null ||
              res?.pickingRestockThreshold === undefined
              ? ''
              : res.pickingRestockThreshold,
          );
        }
      } catch (error) {
        if (active) {
          ToastMessage.apiError(error);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchThreshold();
    return () => {
      active = false;
    };
  }, [open, itemId, warehouseId]);

  const saveThreshold = async () => {
    try {
      setSaving(true);
      const payload = {
        warehouseId,
        pickingRestockThreshold:
          value === '' || value === null || value === undefined ? null : Number(value),
      };
      await ItemService.updateRestockThreshold(itemId, payload);
      ToastMessage.success('Re-stock threshold updated successfully');
      onClose();
      refresh();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SkupremeModal
      open={open}
      onClose={onClose}
      title="Edit Re-Stock Threshold"
      size="tiny"
    >
      <div className="mb-2">
        <Text strong>Pickable Locations</Text>
      </div>
      <InputNumber
        className="w-100"
        min={0}
        value={value === '' ? null : value}
        onChange={val => setValue(val ?? '')}
        disabled={loading || saving}
        placeholder="Use warehouse default"
      />
      <div className="mt-2 mb-4">
        <Text type="secondary">
          If empty, the warehouse default pickable threshold is used.
        </Text>
      </div>
      <div className="d-flex justify-content-end">
        <HoverBorderButton disabled={saving} onClick={onClose}>
          Cancel
        </HoverBorderButton>
        <StyledButton
          loading={saving}
          disabled={loading}
          onClick={saveThreshold}
          className="ml-2"
        >
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
